/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import DehazeIcon from "@material-ui/icons/Dehaze";
import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import { HeaderCartButton } from "components/header/HeaderCartButton";
import { HeaderLoginButton } from "components/header/HeaderLoginButton";
import { BellNotification } from "containers/account/notification/HeaderNotification";
import React from "react";
import { Link } from "react-router-dom";
import { changeStyleWithHosting } from "utility/hosting";

import { HeaderSearch } from "./HeaderSearch";

type Props = {
  uid: string;
  userEmail: string | undefined;
  isEmptyCart: boolean;
  isDisplayLogo: boolean;
  domainLogo: JSX.Element;
  isBackIconRoute: boolean;
  homeLink: string;
  toggleSideMenu: () => void;
  toggleMyCart: () => void;
  toggleLoginMethod: () => void;
  goBack: () => void;
};
export const HeaderSpDisplay: React.FC<Props> = (props) => {
  const classesHeaderForSp = headerDesignForSp();
  const { textColor, svgColor } =
    changeStyleWithHosting().commonSettings.header;

  return (
    <header css={classesHeaderForSp.header}>
      <div css={classesHeaderForSp.container}>
        {props.isBackIconRoute ? (
          <div css={classesHeaderForSp.backToPrev} onClick={props.goBack}>
            <KeyboardArrowLeftIcon />
          </div>
        ) : (
          <div css={classesHeaderForSp.openMenu} onClick={props.toggleSideMenu}>
            <DehazeIcon />
          </div>
        )}

        {props.isDisplayLogo && (
          <h1 css={classesHeaderForSp.logo}>
            <Link to={props.homeLink}>{props.domainLogo}</Link>
          </h1>
        )}

        <div css={classesHeaderForSp.iconList}>
          <HeaderSearch />
          {props.uid ? (
            <React.Fragment>
              <BellNotification />
              <HeaderCartButton
                iconColor={textColor}
                isEmptyCart={props.isEmptyCart}
                onClick={props.toggleMyCart}
              />
            </React.Fragment>
          ) : (
            <HeaderLoginButton
              iconColor={svgColor}
              onClick={props.toggleLoginMethod}
            />
          )}
        </div>
      </div>
    </header>
  );
};

export const headerDesignForSp = () => {
  const { textColor } = changeStyleWithHosting().commonSettings.header;
  return {
    header: css`
      display: block;
      padding: 12px 0;
    `,
    container: css`
      display: flex;
      align-items: center;
      justify-content: space-between;
      width: 90%;
      margin: 0 auto;
    `,
    logo: css`
      height: 20px;
      img {
        height: 100%;
      }
    `,
    backToPrev: css`
      width: 30px;
      height: 30px;
      svg {
        fill: ${textColor};
      }
    `,
    openMenu: css`
      width: 30px;
      svg {
        fill: ${textColor};
      }
    `,
    iconList: css`
      display: flex;
      #badge {
        margin-right: 10px;
      }
      #search {
        margin-right: 10px;
      }
      #bell svg {
        fill: ${textColor};
        cursor: pointer;
      }
    `,
  };
};

export const resetButtonStyles = css`
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
`;
